<div class="item" (click)="click()">
  <div class="inner">
    <div class="image">
      <app-image [src]="imageSource()" [alt]="item().name" />
    </div>
    <div class="content">
      <h3 class="title">{{truncateName(item().name)}}</h3>
      @if (hasAddress()) {
        <div class="pricing">
          <app-price [value]="item().netPrice" />
        </div>
      }
    </div>
  </div>
</div>
